import { useQuery } from "@tanstack/react-query";

import { Status } from "@seneca/surveys-service-types";

import { getClient } from "services";

import { isSignedIn as getIsSignedIn } from "seneca-common/features/user/state";
import { useSelector } from "seneca-common/utils/hooks/selectors";

import useAppVariant from "features/common/hooks/useAppVariant";

import { SURVEYS_KEY } from "../consts";

export default function useFetchAllActiveSurveys() {
  const enabled = useEnabledByVariant();

  return useQuery({
    queryKey: [SURVEYS_KEY],
    queryFn: async () =>
      getClient("surveysService").fetchAllSurveys({ status: Status.active }),
    refetchOnWindowFocus: false,
    retry: false,
    enabled
  });
}

function useEnabledByVariant() {
  const appVariant = useAppVariant();

  const isSignedIn = useSelector(getIsSignedIn);

  const valuesByVariant = {
    seneca: isSignedIn,
    plurall: false,
    goStudentLearning: false
  };

  return valuesByVariant[appVariant];
}
